/** Normalize the collection envelopes returned by current and legacy APIs. */
export function apiCollection<T = any>(value: unknown): T[] {
  if (Array.isArray(value)) return value as T[];
  if (!value || typeof value !== 'object') return [];
  const record = value as Record<string, unknown>;
  for (const key of ['items', 'data', 'results', 'rows']) {
    if (Array.isArray(record[key])) return record[key] as T[];
  }
  return [];
}
